/* eslint-disable jsx-a11y/anchor-is-valid */
import { customerService } from "../../services/customer.service";
import LogicContext from "../../Context/LogicContext";
import { useCallback, useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
// import { GetRecoilCorporateList, SetRecoilCorporateList } from "../../store/corporateAtom";
// import underscore from "underscore";
// import CsvDownload from 'react-json-to-csv';
import RestartAlt from '@mui/icons-material/RestartAlt';
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useNavigate } from "react-router-dom";
import { settingsService } from "../../services/settingsService";
import AddsSettingTable from "./AddsSettingMainTable";
import moment from "moment/moment";
import { GetAdsStoreData, SetAdsStoreData } from "../../store/AddsStoreAtom";
// import { corporateService } from "../../services/corporation.service";
// import RatingMainTable from "./RatingMainTable";
// import { GetRatingListAtom, SetRatingListAtom } from "../../store/ratingAtom";
// import RatingTypeSelect from "./RatingTypeSelect";


function AddsSettingMainPage() {
  const logicContext = useContext(LogicContext);
  const getAtomStoreData = GetAdsStoreData();
const setAtomStore = SetAdsStoreData();
  const [tableList, setTableList] = useState([]);

  const navigate = useNavigate();

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];


  useEffect(()=> {
    document.title = 'Adds setting';

    if(getAtomStoreData.length){
      setTableList(getAtomStoreData);
    }else{
      refreshList();
    }
   
  },[getAtomStoreData]);

  useEffect(() => {
          if (sessionStorage.getItem("reloadPage") === "true") {
            sessionStorage.removeItem("reloadPage");
            refreshList();
          }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
  


  
  function refreshList(){

  settingsService.getAddsSetting().then(response => {
    if(response?.data?.length){
      const tempList =  response.data?.map((item: any)=> {
        return { ...item, Ad_Start_Date : moment(item.Ad_Start_Date).format(" DD-MM-YYYY:HH:mm:ss"),
          Ad_End_Date: moment(item.Ad_End_Date).format(" DD-MM-YYYY:HH:mm:ss")
        }
      });
  
      setAtomStore(tempList);

    }
})


  }
 
  function addNewCorporate(){
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`)
  }





  
  function exportCustomers(){
    // customerService.getAllCustomers().then(res => {
    //   setAllCustomers(res.data);
    // }).catch(err => {
    //   logicContext.showToast('error getting customers data ', 'warning');
    // });
  }



 

  return (
    <>
  
    <section>
      
      <div className="   w-full   lg:flex justify-start">
        <section className=" w-full">
          <section className="bg-white py-4 px-2    md:flex justify-between ">
            <div className="flex px-2 mt-1">
        

         
             
            <Tooltip title="Reload">
           <RestartAlt
             className="cursor ml-2 mt-1"
             onClick={() => refreshList()}
             color="primary"
             fontSize="large"
           />
         </Tooltip>

         <Tooltip title="Total ">
         <div className="card font-weight-bold text-primary p-1 pl-3 pr-3 ml-3  bg-light">
                 Total: {tableList?.length}
         </div>
         </Tooltip>

            </div>
          
            <div >
         
            </div>

            <div className="flex justify-between">
            <div className="   grid grid-cols-1 gap-1 content-center">

            </div>
          
              <button className="  font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8 text-xs">
                IMPORT
              </button>
              <div className="btn-group">
               <button onClick={()=> exportCustomers()} className=" font-[Poppins] font-bold py-2 mt-1 px-2 rounded md:ml-8   text-xs" data-toggle="dropdown" aria-expanded="false">
                EXPORT
              </button>
             
            </div>

            <div className=" grid grid-cols-1 gap-1 content-center">
            <button onClick={addNewCorporate}
                className="bg-buttonColor font-[Poppins] py-2 rounded-md  px-3  text-white text-xs">
                  ADD NEW
                </button>
            </div>
           

               
             
            </div>
          </section>

          <section className="">
        
            <AddsSettingTable tableList={tableList} />
          </section>
        </section>
      </div>
    </section>
    </>

  );
}

export default AddsSettingMainPage;
